import { combineReducers } from '@reduxjs/toolkit';
import { reducer as formReducer } from 'redux-form';
import orderReducer from './reducers/orderReducer';
import postReducer from './reducers/postReducer';
import usersReducer from './reducers/businessReducer';

const reducers = combineReducers({
  form: formReducer,
  order: orderReducer,
  users: usersReducer,
  post: postReducer,
});

export default reducers;
